import type { Dispatch, SetStateAction } from 'react';

import { ICartEntryFragment } from '@fhs-legacy/frontend/src/generated/rbi-graphql';
import { IAddToCartSelectionAttributes } from '@fhs-legacy/frontend/src/state/amplitude/types';
import { ServiceMode } from '@rbi-ctg/menu';
import { IBackendCartEntries, ICartEntry } from '@rbi-ctg/menu';

export type CartOptions = {
  throwOnError?: boolean;
};

export type IDeliveryInputAddress = {
  addressLine1: string;
  addressLine2?: string;
  city: string;
  route?: string;
  state?: string;
  streetNumber?: string;
  zip?: string;
  country?: string;
  latitude: number;
  longitude: number;
};

export type IConvertCartEntry = {
  itemId: string;
  quantity: number;
  modifiersJson: any;
  isCombo: boolean;
  comboItemsJson: any;
  price: number;
  comboId?: string;
  //Additional context data
  pickerSelections: Record<string, string>;
  storeId: string;
  serviceMode?: ServiceMode;
};

export type ICartStore = {
  cartEntries: ICartEntry[];
  getBackendCartEntries: () => IBackendCartEntries[];
};

export type ICartStoreActions = {
  addItemToCartStore: (cartEntry: ICartEntry) => void;
  removeItemFromCartStore: (cartEntryToRemove: ICartEntry) => void;
  replaceItemsInCartStore: (newCartEntries: ICartEntry[]) => void;
  emptyCartStore: () => void;
};

export type ICartActions = {
  addItemToCart: (
    cartEntry: ICartEntry | IBackendCartEntries | ICartEntryFragment | null,
    eventAttrs?: IAddToCartSelectionAttributes | undefined,
    showMessage?: boolean
  ) => void;
  addMultipleItemsToCart: ({
    newCartEntries,
    eventAttrs,
    shouldShowMessage,
  }: {
    newCartEntries: ICartEntry[];
    eventAttrs?: IAddToCartSelectionAttributes;
    shouldShowMessage?: boolean;
  }) => void;
  removeItemFromCart: ({ cartId }: { cartId: string }) => void;
  removeAllItemsFromCart: (cartEntriesToRemove: ICartEntry[]) => void;
  updateCartEntry: (newCartEntry: ICartEntry, originalCartEntry: ICartEntry) => void;
  updateMultipleCartEntries: (
    entriesToUpdate: ICartEntry[],
    allOriginalCartEntries?: ICartEntry[]
  ) => void;
  repriceCartEntries: (
    entries: ICartEntry[],
    parentEntry: unknown,
    mainCombo: unknown
  ) => ICartEntry[];
  upsertCart: (newCartEntries: ICartEntry[], eventAttrs?: IAddToCartSelectionAttributes) => void;
  updateCartItemsQuantity: (cartId: string, quantity: number) => void;
  emptyCart: (
    setCartIdEditing: Dispatch<SetStateAction<string>>,
    isDonationZeroAmountSelected: boolean,
    setIsDonationZeroAmountSelected: Dispatch<SetStateAction<boolean>>
  ) => void;
  isCartEntryInSwaps: (cartEntry: ICartEntry) => boolean;
  swapCartItems: (to: any, swapOffer: any) => ICartEntry[];
};
